import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { workspaceBase } from './api-base';

// Send the session cookie when the gateway resolves cross-origin (no-op same-origin).
const WITH_CREDENTIALS = { withCredentials: true } as const;

/**
 * A workspace-AI chart definition. `options` is the opaque ECharts option object
 * the chat renders inline; the artifact preview re-renders it at panel size.
 */
export interface WorkspaceChartDefinition {
  id: string;
  name: string;
  options: unknown;
  draft?: boolean;
}

/**
 * Fetches/persists workspace-AI charts referenced by artifact actions. Charts
 * live at `${workspaceBase(id)}/charts/:chartId` on the same gateway as the chat
 * stream (a sibling of `/ai`). Auth comes from `aiWorkspaceAuthInterceptor`.
 */
@Injectable({ providedIn: 'root' })
export class SdocsChartApi {
  private readonly http = inject(HttpClient);

  public getChart(workspaceId: string, chartId: string): Observable<WorkspaceChartDefinition> {
    return this.http.get<WorkspaceChartDefinition>(this.chartUrl(workspaceId, chartId), WITH_CREDENTIALS);
  }

  /** Persist a draft chart (clear its draft flag). */
  public saveChart(workspaceId: string, chartId: string): Observable<WorkspaceChartDefinition> {
    return this.http.patch<WorkspaceChartDefinition>(this.chartUrl(workspaceId, chartId), { draft: false }, WITH_CREDENTIALS);
  }

  private chartUrl(workspaceId: string, chartId: string): string {
    return `${workspaceBase(workspaceId)}/charts/${chartId}`;
  }
}
